"use client";

import { Product, Variant } from "interfaces/products";
import BlurFade from "./ui/blur-fade";

interface Props {
  product: Product;
  selectedVariant: Variant;
}

const CataloguePicture = ({ product, selectedVariant }: Props) => {
  const getPictureUrl = () => {
    if (!selectedVariant) {
      return product?.pictures[0]?.picture.path;
    }

    if (selectedVariant?.pictures[0]?.picture.path) {
      return selectedVariant?.pictures[0]?.picture.path;
    }

    return product?.pictures[0]?.picture.path;
  };

  const pictureUrl = getPictureUrl();

  if (!pictureUrl) return null;

  return (
    <BlurFade
      key={pictureUrl}
      delay={0.25 + Math.random() * 10 * 0.05}
      className="border-0 flex justify-center p-0 relative h-32 w-40"
    >
      <img
        src={pictureUrl}
        alt={""}
        style={{ objectFit: "contain" }}
        className="transition duration-500 hover:scale-150"
      />
    </BlurFade>
  );
};

export default CataloguePicture;
